export default [
  { value: 'alert', className: 'ion-alert' },
  { value: 'alert-circled', className: 'ion-alert-circled' },
  { value: 'android-add', className: 'ion-android-add' },
  { value: 'android-add-circle', className: 'ion-android-add-circle' },
  { value: 'android-alarm-clock', className: 'ion-android-alarm-clock' },
  { value: 'android-alert', className: 'ion-android-alert' },
  { value: 'android-apps', className: 'ion-android-apps' },
  { value: 'android-archive', className: 'ion-android-archive' },
  { value: 'android-arrow-back', className: 'ion-android-arrow-back' },
  { value: 'android-arrow-down', className: 'ion-android-arrow-down' },
  { value: 'android-arrow-dropdown', className: 'ion-android-arrow-dropdown' },
  { value: 'android-arrow-dropdown-circle', className: 'ion-android-arrow-dropdown-circle' },
  { value: 'android-arrow-dropleft', className: 'ion-android-arrow-dropleft' },
  { value: 'android-arrow-dropleft-circle', className: 'ion-android-arrow-dropleft-circle' },
  { value: 'android-arrow-dropright', className: 'ion-android-arrow-dropright' },
  { value: 'android-arrow-dropright-circle', className: 'ion-android-arrow-dropright-circle' },
  { value: 'android-arrow-dropup', className: 'ion-android-arrow-dropup' },
  { value: 'android-arrow-dropup-circle', className: 'ion-android-arrow-dropup-circle' },
  { value: 'android-arrow-forward', className: 'ion-android-arrow-forward' },
  { value: 'android-arrow-up', className: 'ion-android-arrow-up' },
  { value: 'android-attach', className: 'ion-android-attach' },
  { value: 'android-bar', className: 'ion-android-bar' },
  { value: 'android-bicycle', className: 'ion-android-bicycle' },
  { value: 'android-boat', className: 'ion-android-boat' },
  { value: 'android-bookmark', className: 'ion-android-bookmark' },
  { value: 'android-bulb', className: 'ion-android-bulb' },
  { value: 'android-bus', className: 'ion-android-bus' },
  { value: 'android-calendar', className: 'ion-android-calendar' },
  { value: 'android-call', className: 'ion-android-call' },
  { value: 'android-camera', className: 'ion-android-camera' },
  { value: 'android-cancel', className: 'ion-android-cancel' },
  { value: 'android-car', className: 'ion-android-car' },
  { value: 'android-cart', className: 'ion-android-cart' },
  { value: 'android-chat', className: 'ion-android-chat' },
  { value: 'android-checkbox', className: 'ion-android-checkbox' },
  { value: 'android-checkbox-blank', className: 'ion-android-checkbox-blank' },
  { value: 'android-checkbox-outline', className: 'ion-android-checkbox-outline' },
  { value: 'android-checkbox-outline-blank', className: 'ion-android-checkbox-outline-blank' },
  { value: 'android-checkmark-circle', className: 'ion-android-checkmark-circle' },
  { value: 'android-clipboard', className: 'ion-android-clipboard' },
  { value: 'android-close', className: 'ion-android-close' },
  { value: 'android-cloud', className: 'ion-android-cloud' },
  { value: 'android-cloud-circle', className: 'ion-android-cloud-circle' },
  { value: 'android-cloud-done', className: 'ion-android-cloud-done' },
  { value: 'android-cloud-outline', className: 'ion-android-cloud-outline' },
  { value: 'android-color-palette', className: 'ion-android-color-palette' },
  { value: 'android-compass', className: 'ion-android-compass' },
  { value: 'android-contact', className: 'ion-android-contact' },
  { value: 'android-contacts', className: 'ion-android-contacts' },
  { value: 'android-contract', className: 'ion-android-contract' },
  { value: 'android-create', className: 'ion-android-create' },
  { value: 'android-delete', className: 'ion-android-delete' },
  { value: 'android-desktop', className: 'ion-android-desktop' },
  { value: 'android-document', className: 'ion-android-document' },
  { value: 'android-done', className: 'ion-android-done' },
  { value: 'android-done-all', className: 'ion-android-done-all' },
  { value: 'android-download', className: 'ion-android-download' },
  { value: 'android-drafts', className: 'ion-android-drafts' },
  { value: 'android-exit', className: 'ion-android-exit' },
  { value: 'android-expand', className: 'ion-android-expand' },
  { value: 'android-favorite', className: 'ion-android-favorite' },
  { value: 'android-favorite-outline', className: 'ion-android-favorite-outline' },
  { value: 'android-film', className: 'ion-android-film' },
  { value: 'android-folder', className: 'ion-android-folder' },
  { value: 'android-folder-open', className: 'ion-android-folder-open' },
  { value: 'android-funnel', className: 'ion-android-funnel' },
  { value: 'android-globe', className: 'ion-android-globe' },
  { value: 'android-hand', className: 'ion-android-hand' },
  { value: 'android-hangout', className: 'ion-android-hangout' },
  { value: 'android-happy', className: 'ion-android-happy' },
  { value: 'android-home', className: 'ion-android-home' },
  { value: 'android-image', className: 'ion-android-image' },
  { value: 'android-laptop', className: 'ion-android-laptop' },
  { value: 'android-list', className: 'ion-android-list' },
  { value: 'android-locate', className: 'ion-android-locate' },
  { value: 'android-lock', className: 'ion-android-lock' },
  { value: 'android-mail', className: 'ion-android-mail' },
  { value: 'android-map', className: 'ion-android-map' },
  { value: 'android-menu', className: 'ion-android-menu' },
  { value: 'android-microphone', className: 'ion-android-microphone' },
  { value: 'android-microphone-off', className: 'ion-android-microphone-off' },
  { value: 'android-more-horizontal', className: 'ion-android-more-horizontal' },
  { value: 'android-more-vertical', className: 'ion-android-more-vertical' },
  { value: 'android-navigate', className: 'ion-android-navigate' },
  { value: 'android-notifications', className: 'ion-android-notifications' },
  { value: 'android-notifications-none', className: 'ion-android-notifications-none' },
  { value: 'android-notifications-off', className: 'ion-android-notifications-off' },
  { value: 'android-open', className: 'ion-android-open' },
  { value: 'android-options', className: 'ion-android-options' },
  { value: 'android-people', className: 'ion-android-people' },
  { value: 'android-person', className: 'ion-android-person' },
  { value: 'android-person-add', className: 'ion-android-person-add' },
  { value: 'android-phone-landscape', className: 'ion-android-phone-landscape' },
  { value: 'android-phone-portrait', className: 'ion-android-phone-portrait' },
  { value: 'android-pin', className: 'ion-android-pin' },
  { value: 'android-plane', className: 'ion-android-plane' },
  { value: 'android-playstore', className: 'ion-android-playstore' },
  { value: 'android-print', className: 'ion-android-print' },
  { value: 'android-radio-button-on', className: 'ion-android-radio-button-on' },
  { value: 'android-radio-button-off', className: 'ion-android-radio-button-off' },
  { value: 'android-refresh', className: 'ion-android-refresh' },
  { value: 'android-remove', className: 'ion-android-remove' },
  { value: 'android-remove-circle', className: 'ion-android-remove-circle' },
  { value: 'android-restaurant', className: 'ion-android-restaurant' },
  { value: 'android-sad', className: 'ion-android-sad' },
  { value: 'android-search', className: 'ion-android-search' },
  { value: 'android-send', className: 'ion-android-send' },
  { value: 'android-settings', className: 'ion-android-settings' },
  { value: 'android-share', className: 'ion-android-share' },
  { value: 'android-share-alt', className: 'ion-android-share-alt' },
  { value: 'android-star', className: 'ion-android-star' },
  { value: 'android-star-half', className: 'ion-android-star-half' },
  { value: 'android-star-outline', className: 'ion-android-star-outline' },
  { value: 'android-stopwatch', className: 'ion-android-stopwatch' },
  { value: 'android-subway', className: 'ion-android-subway' },
  { value: 'android-sunny', className: 'ion-android-sunny' },
  { value: 'android-sync', className: 'ion-android-sync' },
  { value: 'android-textsms', className: 'ion-android-textsms' },
  { value: 'android-time', className: 'ion-android-time' },
  { value: 'android-train', className: 'ion-android-train' },
  { value: 'android-unlock', className: 'ion-android-unlock' },
  { value: 'android-upload', className: 'ion-android-upload' },
  { value: 'android-volume-down', className: 'ion-android-volume-down' },
  { value: 'android-volume-mute', className: 'ion-android-volume-mute' },
  { value: 'android-volume-off', className: 'ion-android-volume-off' },
  { value: 'android-volume-up', className: 'ion-android-volume-up' },
  { value: 'android-walk', className: 'ion-android-walk' },
  { value: 'android-warning', className: 'ion-android-warning' },
  { value: 'android-watch', className: 'ion-android-watch' },
  { value: 'android-wifi', className: 'ion-android-wifi' },
  { value: 'aperture', className: 'ion-aperture' },
  { value: 'archive', className: 'ion-archive' },
  { value: 'arrow-down-a', className: 'ion-arrow-down-a' },
  { value: 'arrow-down-b', className: 'ion-arrow-down-b' },
  { value: 'arrow-down-c', className: 'ion-arrow-down-c' },
  { value: 'arrow-expand', className: 'ion-arrow-expand' },
  { value: 'arrow-graph-down-left', className: 'ion-arrow-graph-down-left' },
  { value: 'arrow-graph-down-right', className: 'ion-arrow-graph-down-right' },
  { value: 'arrow-graph-up-left', className: 'ion-arrow-graph-up-left' },
  { value: 'arrow-graph-up-right', className: 'ion-arrow-graph-up-right' },
  { value: 'arrow-left-a', className: 'ion-arrow-left-a' },
  { value: 'arrow-left-b', className: 'ion-arrow-left-b' },
  { value: 'arrow-left-c', className: 'ion-arrow-left-c' },
  { value: 'arrow-move', className: 'ion-arrow-move' },
  { value: 'arrow-resize', className: 'ion-arrow-resize' },
  { value: 'arrow-return-left', className: 'ion-arrow-return-left' },
  { value: 'arrow-return-right', className: 'ion-arrow-return-right' },
  { value: 'arrow-right-a', className: 'ion-arrow-right-a' },
  { value: 'arrow-right-b', className: 'ion-arrow-right-b' },
  { value: 'arrow-right-c', className: 'ion-arrow-right-c' },
  { value: 'arrow-shrink', className: 'ion-arrow-shrink' },
  { value: 'arrow-swap', className: 'ion-arrow-swap' },
  { value: 'arrow-up-a', className: 'ion-arrow-up-a' },
  { value: 'arrow-up-b', className: 'ion-arrow-up-b' },
  { value: 'arrow-up-c', className: 'ion-arrow-up-c' },
  { value: 'asterisk', className: 'ion-asterisk' },
  { value: 'at', className: 'ion-at' },
  { value: 'backspace', className: 'ion-backspace' },
  { value: 'backspace-outline', className: 'ion-backspace-outline' },
  { value: 'bag', className: 'ion-bag' },
  { value: 'battery-charging', className: 'ion-battery-charging' },
  { value: 'battery-empty', className: 'ion-battery-empty' },
  { value: 'battery-full', className: 'ion-battery-full' },
  { value: 'battery-half', className: 'ion-battery-half' },
  { value: 'battery-low', className: 'ion-battery-low' },
  { value: 'beaker', className: 'ion-beaker' },
  { value: 'beer', className: 'ion-beer' },
  { value: 'bluetooth', className: 'ion-bluetooth' },
  { value: 'bonfire', className: 'ion-bonfire' },
  { value: 'bookmark', className: 'ion-bookmark' },
  { value: 'bowtie', className: 'ion-bowtie' },
  { value: 'briefcase', className: 'ion-briefcase' },
  { value: 'bug', className: 'ion-bug' },
  { value: 'calculator', className: 'ion-calculator' },
  { value: 'calendar', className: 'ion-calendar' },
  { value: 'camera', className: 'ion-camera' },
  { value: 'card', className: 'ion-card' },
  { value: 'cash', className: 'ion-cash' },
  { value: 'chatbox', className: 'ion-chatbox' },
  { value: 'chatbox-working', className: 'ion-chatbox-working' },
  { value: 'chatboxes', className: 'ion-chatboxes' },
  { value: 'chatbubble', className: 'ion-chatbubble' },
  { value: 'chatbubble-working', className: 'ion-chatbubble-working' },
  { value: 'chatbubbles', className: 'ion-chatbubbles' },
  { value: 'checkmark', className: 'ion-checkmark' },
  { value: 'checkmark-circled', className: 'ion-checkmark-circled' },
  { value: 'checkmark-round', className: 'ion-checkmark-round' },
  { value: 'chevron-down', className: 'ion-chevron-down' },
  { value: 'chevron-left', className: 'ion-chevron-left' },
  { value: 'chevron-right', className: 'ion-chevron-right' },
  { value: 'chevron-up', className: 'ion-chevron-up' },
  { value: 'clipboard', className: 'ion-clipboard' },
  { value: 'closed-captioning', className: 'ion-closed-captioning' },
  { value: 'clock', className: 'ion-clock' },
  { value: 'close', className: 'ion-close' },
  { value: 'close-circled', className: 'ion-close-circled' },
  { value: 'close-round', className: 'ion-close-round' },
  { value: 'closed-captioning', className: 'ion-closed-captioning' },
  { value: 'cloud', className: 'ion-cloud' },
  { value: 'code', className: 'ion-code' },
  { value: 'code-download', className: 'ion-code-download' },
  { value: 'code-working', className: 'ion-code-working' },
  { value: 'coffee', className: 'ion-coffee' },
  { value: 'compass', className: 'ion-compass' },
  { value: 'compose', className: 'ion-compose' },
  { value: 'connection-bars', className: 'ion-connection-bars' },
  { value: 'contrast', className: 'ion-contrast' },
  { value: 'crop', className: 'ion-crop' },
  { value: 'cube', className: 'ion-cube' },
  { value: 'disc', className: 'ion-disc' },
  { value: 'document', className: 'ion-document' },
  { value: 'document-text', className: 'ion-document-text' },
  { value: 'drag', className: 'ion-drag' },
  { value: 'earth', className: 'ion-earth' },
  { value: 'easel', className: 'ion-easel' },
  { value: 'edit', className: 'ion-edit' },
  { value: 'egg', className: 'ion-egg' },
  { value: 'eject', className: 'ion-eject' },
  { value: 'email', className: 'ion-email' },
  { value: 'email-unread', className: 'ion-email-unread' },
  { value: 'erlenmeyer-flask', className: 'ion-erlenmeyer-flask' },
  { value: 'erlenmeyer-flask-bubbles', className: 'ion-erlenmeyer-flask-bubbles' },
  { value: 'eye', className: 'ion-eye' },
  { value: 'eye-disabled', className: 'ion-eye-disabled' },
  { value: 'female', className: 'ion-female' },
  { value: 'filing', className: 'ion-filing' },
  { value: 'film-marker', className: 'ion-film-marker' },
  { value: 'fireball', className: 'ion-fireball' },
  { value: 'flag', className: 'ion-flag' },
  { value: 'flame', className: 'ion-flame' },
  { value: 'flash', className: 'ion-flash' },
  { value: 'flash-off', className: 'ion-flash-off' },
  { value: 'folder', className: 'ion-folder' },
  { value: 'fork', className: 'ion-fork' },
  { value: 'fork-repo', className: 'ion-fork-repo' },
  { value: 'forward', className: 'ion-forward' },
  { value: 'funnel', className: 'ion-funnel' },
  { value: 'gear-a', className: 'ion-gear-a' },
  { value: 'gear-b', className: 'ion-gear-b' },
  { value: 'grid', className: 'ion-grid' },
  { value: 'hammer', className: 'ion-hammer' },
  { value: 'happy', className: 'ion-happy' },
  { value: 'headphone', className: 'ion-headphone' },
  { value: 'heart', className: 'ion-heart' },
  { value: 'heart-broken', className: 'ion-heart-broken' },
  { value: 'help', className: 'ion-help' },
  { value: 'help-buoy', className: 'ion-help-buoy' },
  { value: 'help-circled', className: 'ion-help-circled' },
  { value: 'home', className: 'ion-home' },
  { value: 'icecream', className: 'ion-icecream' },
  { value: 'image', className: 'ion-image' },
  { value: 'images', className: 'ion-images' },
  { value: 'information', className: 'ion-information' },
  { value: 'information-circled', className: 'ion-information-circled' },
  { value: 'ionic', className: 'ion-ionic' },
  { value: 'ios-alarm', className: 'ion-ios-alarm' },
  { value: 'ios-alarm-outline', className: 'ion-ios-alarm-outline' },
  { value: 'ios-albums', className: 'ion-ios-albums' },
  { value: 'ios-albums-outline', className: 'ion-ios-albums-outline' },
  { value: 'ios-americanfootball', className: 'ion-ios-americanfootball' },
  { value: 'ios-americanfootball-outline', className: 'ion-ios-americanfootball-outline' },
  { value: 'ios-analytics', className: 'ion-ios-analytics' },
  { value: 'ios-analytics-outline', className: 'ion-ios-analytics-outline' },
  { value: 'ios-arrow-back', className: 'ion-ios-arrow-back' },
  { value: 'ios-arrow-down', className: 'ion-ios-arrow-down' },
  { value: 'ios-arrow-forward', className: 'ion-ios-arrow-forward' },
  { value: 'ios-arrow-left', className: 'ion-ios-arrow-left' },
  { value: 'ios-arrow-right', className: 'ion-ios-arrow-right' },
  { value: 'ios-arrow-thin-down', className: 'ion-ios-arrow-thin-down' },
  { value: 'ios-arrow-thin-left', className: 'ion-ios-arrow-thin-left' },
  { value: 'ios-arrow-thin-right', className: 'ion-ios-arrow-thin-right' },
  { value: 'ios-arrow-thin-up', className: 'ion-ios-arrow-thin-up' },
  { value: 'ios-arrow-up', className: 'ion-ios-arrow-up' },
  { value: 'ios-at', className: 'ion-ios-at' },
  { value: 'ios-at-outline', className: 'ion-ios-at-outline' },
  { value: 'ios-barcode', className: 'ion-ios-barcode' },
  { value: 'ios-barcode-outline', className: 'ion-ios-barcode-outline' },
  { value: 'ios-baseball', className: 'ion-ios-baseball' },
  { value: 'ios-baseball-outline', className: 'ion-ios-baseball-outline' },
  { value: 'ios-basketball', className: 'ion-ios-basketball' },
  { value: 'ios-basketball-outline', className: 'ion-ios-basketball-outline' },
  { value: 'ios-bell', className: 'ion-ios-bell' },
  { value: 'ios-bell-outline', className: 'ion-ios-bell-outline' },
  { value: 'ios-body', className: 'ion-ios-body' },
  { value: 'ios-body-outline', className: 'ion-ios-body-outline' },
  { value: 'ios-bolt', className: 'ion-ios-bolt' },
  { value: 'ios-bolt-outline', className: 'ion-ios-bolt-outline' },
  { value: 'ios-book', className: 'ion-ios-book' },
  { value: 'ios-book-outline', className: 'ion-ios-book-outline' },
  { value: 'ios-bookmarks', className: 'ion-ios-bookmarks' },
  { value: 'ios-bookmarks-outline', className: 'ion-ios-bookmarks-outline' },
  { value: 'ios-box', className: 'ion-ios-box' },
  { value: 'ios-box-outline', className: 'ion-ios-box-outline' },
  { value: 'ios-briefcase', className: 'ion-ios-briefcase' },
  { value: 'ios-briefcase-outline', className: 'ion-ios-briefcase-outline' },
  { value: 'ios-browsers', className: 'ion-ios-browsers' },
  { value: 'ios-browsers-outline', className: 'ion-ios-browsers-outline' },
  { value: 'ios-calculator', className: 'ion-ios-calculator' },
  { value: 'ios-calculator-outline', className: 'ion-ios-calculator-outline' },
  { value: 'ios-calendar', className: 'ion-ios-calendar' },
  { value: 'ios-calendar-outline', className: 'ion-ios-calendar-outline' },
  { value: 'ios-camera', className: 'ion-ios-camera' },
  { value: 'ios-camera-outline', className: 'ion-ios-camera-outline' },
  { value: 'ios-cart', className: 'ion-ios-cart' },
  { value: 'ios-cart-outline', className: 'ion-ios-cart-outline' },
  { value: 'ios-chatboxes', className: 'ion-ios-chatboxes' },
  { value: 'ios-chatboxes-outline', className: 'ion-ios-chatboxes-outline' },
  { value: 'ios-chatbubble', className: 'ion-ios-chatbubble' },
  { value: 'ios-chatbubble-outline', className: 'ion-ios-chatbubble-outline' },
  { value: 'ios-checkmark', className: 'ion-ios-checkmark' },
  { value: 'ios-checkmark-empty', className: 'ion-ios-checkmark-empty' },
  { value: 'ios-checkmark-outline', className: 'ion-ios-checkmark-outline' },
  { value: 'ios-circle-filled', className: 'ion-ios-circle-filled' },
  { value: 'ios-circle-outline', className: 'ion-ios-circle-outline' },
  { value: 'ios-clock', className: 'ion-ios-clock' },
  { value: 'ios-clock-outline', className: 'ion-ios-clock-outline' },
  { value: 'ios-close', className: 'ion-ios-close' },
  { value: 'ios-close-empty', className: 'ion-ios-close-empty' },
  { value: 'ios-close-outline', className: 'ion-ios-close-outline' },
  { value: 'ios-cloud', className: 'ion-ios-cloud' },
  { value: 'ios-cloud-download', className: 'ion-ios-cloud-download' },
  { value: 'ios-cloud-download-outline', className: 'ion-ios-cloud-download-outline' },
  { value: 'ios-cloud-outline', className: 'ion-ios-cloud-outline' },
  { value: 'ios-cloud-upload', className: 'ion-ios-cloud-upload' },
  { value: 'ios-cloud-upload-outline', className: 'ion-ios-cloud-upload-outline' },
  { value: 'ios-cloudy', className: 'ion-ios-cloudy' },
  { value: 'ios-cloudy-night', className: 'ion-ios-cloudy-night' },
  { value: 'ios-cloudy-night-outline', className: 'ion-ios-cloudy-night-outline' },
  { value: 'ios-cloudy-outline', className: 'ion-ios-cloudy-outline' },
  { value: 'ios-cog', className: 'ion-ios-cog' },
  { value: 'ios-cog-outline', className: 'ion-ios-cog-outline' },
  { value: 'ios-color-filter', className: 'ion-ios-color-filter' },
  { value: 'ios-color-filter-outline', className: 'ion-ios-color-filter-outline' },
  { value: 'ios-color-wand', className: 'ion-ios-color-wand' },
  { value: 'ios-color-wand-outline', className: 'ion-ios-color-wand-outline' },
  { value: 'ios-compose', className: 'ion-ios-compose' },
  { value: 'ios-compose-outline', className: 'ion-ios-compose-outline' },
  { value: 'ios-contact', className: 'ion-ios-contact' },
  { value: 'ios-contact-outline', className: 'ion-ios-contact-outline' },
  { value: 'ios-copy', className: 'ion-ios-copy' },
  { value: 'ios-copy-outline', className: 'ion-ios-copy-outline' },
  { value: 'ios-crop', className: 'ion-ios-crop' },
  { value: 'ios-crop-strong', className: 'ion-ios-crop-strong' },
  { value: 'ios-download', className: 'ion-ios-download' },
  { value: 'ios-download-outline', className: 'ion-ios-download-outline' },
  { value: 'ios-drag', className: 'ion-ios-drag' },
  { value: 'ios-email', className: 'ion-ios-email' },
  { value: 'ios-email-outline', className: 'ion-ios-email-outline' },
  { value: 'ios-eye', className: 'ion-ios-eye' },
  { value: 'ios-eye-outline', className: 'ion-ios-eye-outline' },
  { value: 'ios-fastforward', className: 'ion-ios-fastforward' },
  { value: 'ios-fastforward-outline', className: 'ion-ios-fastforward-outline' },
  { value: 'ios-filing', className: 'ion-ios-filing' },
  { value: 'ios-film', className: 'ion-ios-film' },
  { value: 'ios-film-outline', className: 'ion-ios-film-outline' },
  { value: 'ios-flag', className: 'ion-ios-flag' },
  { value: 'ios-flag-outline', className: 'ion-ios-flag-outline' },
  { value: 'ios-flame', className: 'ion-ios-flame' },
  { value: 'ios-flame-outline', className: 'ion-ios-flame-outline' },
  { value: 'ios-flask', className: 'ion-ios-flask' },
  { value: 'ios-flask-outline', className: 'ion-ios-flask-outline' },
  { value: 'ios-flower', className: 'ion-ios-flower' },
  { value: 'ios-flower-outline', className: 'ion-ios-flower-outline' },
  { value: 'ios-folder', className: 'ion-ios-folder' },
  { value: 'ios-folder-outline', className: 'ion-ios-folder-outline' },
  { value: 'ios-football', className: 'ion-ios-football' },
  { value: 'ios-football-outline', className: 'ion-ios-football-outline' },
  { value: 'ios-game-controller-a', className: 'ion-ios-game-controller-a' },
  { value: 'ios-game-controller-a-outline', className: 'ion-ios-game-controller-a-outline' },
  { value: 'ios-game-controller-b', className: 'ion-ios-game-controller-b' },
  { value: 'ios-game-controller-b-outline', className: 'ion-ios-game-controller-b-outline' },
  { value: 'ios-gear', className: 'ion-ios-gear' },
  { value: 'ios-gear-outline', className: 'ion-ios-gear-outline' },
  { value: 'ios-glasses', className: 'ion-ios-glasses' },
  { value: 'ios-glasses-outline', className: 'ion-ios-glasses-outline' },
  { value: 'ios-grid-view', className: 'ion-ios-grid-view' },
  { value: 'ios-grid-view-outline', className: 'ion-ios-grid-view-outline' },
  { value: 'ios-heart', className: 'ion-ios-heart' },
  { value: 'ios-heart-outline', className: 'ion-ios-heart-outline' },
  { value: 'ios-help', className: 'ion-ios-help' },
  { value: 'ios-help-empty', className: 'ion-ios-help-empty' },
  { value: 'ios-help-outline', className: 'ion-ios-help-outline' },
  { value: 'ios-home-outline', className: 'ion-ios-home-outline' },
  { value: 'ios-home', className: 'ion-ios-home' },
  { value: 'ios-infinite', className: 'ion-ios-infinite' },
  { value: 'ios-infinite-outline', className: 'ion-ios-infinite-outline' },
  { value: 'ios-information', className: 'ion-ios-information' },
  { value: 'ios-information-empty', className: 'ion-ios-information-empty' },
  { value: 'ios-information-outline', className: 'ion-ios-information-outline' },
  { value: 'ios-ionic-outline', className: 'ion-ios-ionic-outline' },
  { value: 'ios-keypad', className: 'ion-ios-keypad' },
  { value: 'ios-keypad-outline', className: 'ion-ios-keypad-outline' },
  { value: 'ios-lightbulb', className: 'ion-ios-lightbulb' },
  { value: 'ios-lightbulb-outline', className: 'ion-ios-lightbulb-outline' },
  { value: 'ios-list', className: 'ion-ios-list' },
  { value: 'ios-list-outline', className: 'ion-ios-list-outline' },
  { value: 'ios-location', className: 'ion-ios-location' },
  { value: 'ios-location-outline', className: 'ion-ios-location-outline' },
  { value: 'ios-locked', className: 'ion-ios-locked' },
  { value: 'ios-locked-outline', className: 'ion-ios-locked-outline' },
  { value: 'ios-loop', className: 'ion-ios-loop' },
  { value: 'ios-loop-strong', className: 'ion-ios-loop-strong' },
  { value: 'ios-medical', className: 'ion-ios-medical' },
  { value: 'ios-medical-outline', className: 'ion-ios-medical-outline' },
  { value: 'ios-medkit', className: 'ion-ios-medkit' },
  { value: 'ios-medkit-outline', className: 'ion-ios-medkit-outline' },
  { value: 'ios-mic', className: 'ion-ios-mic' },
  { value: 'ios-mic-off', className: 'ion-ios-mic-off' },
  { value: 'ios-mic-outline', className: 'ion-ios-mic-outline' },
  { value: 'ios-minus', className: 'ion-ios-minus' },
  { value: 'ios-minus-empty', className: 'ion-ios-minus-empty' },
  { value: 'ios-minus-outline', className: 'ion-ios-minus-outline' },
  { value: 'ios-monitor', className: 'ion-ios-monitor' },
  { value: 'ios-monitor-outline', className: 'ion-ios-monitor-outline' },
  { value: 'ios-moon', className: 'ion-ios-moon' },
  { value: 'ios-moon-outline', className: 'ion-ios-moon-outline' },
  { value: 'ios-more', className: 'ion-ios-more' },
  { value: 'ios-more-outline', className: 'ion-ios-more-outline' },
  { value: 'ios-musical-note', className: 'ion-ios-musical-note' },
  { value: 'ios-musical-notes', className: 'ion-ios-musical-notes' },
  { value: 'ios-navigate', className: 'ion-ios-navigate' },
  { value: 'ios-navigate-outline', className: 'ion-ios-navigate-outline' },
  { value: 'ios-nutrition', className: 'ion-ios-nutrition' },
  { value: 'ios-nutrition-outline', className: 'ion-ios-nutrition-outline' },
  { value: 'ios-paper', className: 'ion-ios-paper' },
  { value: 'ios-paper-outline', className: 'ion-ios-paper-outline' },
  { value: 'ios-paperplane', className: 'ion-ios-paperplane' },
  { value: 'ios-paperplane-outline', className: 'ion-ios-paperplane-outline' },
  { value: 'ios-partlysunny', className: 'ion-ios-partlysunny' },
  { value: 'ios-partlysunny-outline', className: 'ion-ios-partlysunny-outline' },
  { value: 'ios-pause', className: 'ion-ios-pause' },
  { value: 'ios-pause-outline', className: 'ion-ios-pause-outline' },
  { value: 'ios-paw', className: 'ion-ios-paw' },
  { value: 'ios-paw-outline', className: 'ion-ios-paw-outline' },
  { value: 'ios-people', className: 'ion-ios-people' },
  { value: 'ios-people-outline', className: 'ion-ios-people-outline' },
  { value: 'ios-person', className: 'ion-ios-person' },
  { value: 'ios-person-outline', className: 'ion-ios-person-outline' },
  { value: 'ios-personadd', className: 'ion-ios-personadd' },
  { value: 'ios-personadd-outline', className: 'ion-ios-personadd-outline' },
  { value: 'ios-photos', className: 'ion-ios-photos' },
  { value: 'ios-photos-outline', className: 'ion-ios-photos-outline' },
  { value: 'ios-pie', className: 'ion-ios-pie' },
  { value: 'ios-pie-outline', className: 'ion-ios-pie-outline' },
  { value: 'ios-pint', className: 'ion-ios-pint' },
  { value: 'ios-pint-outline', className: 'ion-ios-pint-outline' },
  { value: 'ios-play', className: 'ion-ios-play' },
  { value: 'ios-play-outline', className: 'ion-ios-play-outline' },
  { value: 'ios-plus', className: 'ion-ios-plus' },
  { value: 'ios-plus-empty', className: 'ion-ios-plus-empty' },
  { value: 'ios-plus-outline', className: 'ion-ios-plus-outline' },
  { value: 'ios-pricetag', className: 'ion-ios-pricetag' },
  { value: 'ios-pricetag-outline', className: 'ion-ios-pricetag-outline' },
  { value: 'ios-pricetags', className: 'ion-ios-pricetags' },
  { value: 'ios-pricetags-outline', className: 'ion-ios-pricetags-outline' },
  { value: 'ios-printer', className: 'ion-ios-printer' },
  { value: 'ios-printer-outline', className: 'ion-ios-printer-outline' },
  { value: 'ios-pulse', className: 'ion-ios-pulse' },
  { value: 'ios-pulse-strong', className: 'ion-ios-pulse-strong' },
  { value: 'ios-rainy', className: 'ion-ios-rainy' },
  { value: 'ios-rainy-outline', className: 'ion-ios-rainy-outline' },
  { value: 'ios-recording', className: 'ion-ios-recording' },
  { value: 'ios-recording-outline', className: 'ion-ios-recording-outline' },
  { value: 'ios-redo', className: 'ion-ios-redo' },
  { value: 'ios-redo-outline', className: 'ion-ios-redo-outline' },
  { value: 'ios-refresh', className: 'ion-ios-refresh' },
  { value: 'ios-refresh-empty', className: 'ion-ios-refresh-empty' },
  { value: 'ios-refresh-outline', className: 'ion-ios-refresh-outline' },
  { value: 'ios-reload', className: 'ion-ios-reload' },
  { value: 'ios-reverse-camera', className: 'ion-ios-reverse-camera' },
  { value: 'ios-reverse-camera-outline', className: 'ion-ios-reverse-camera-outline' },
  { value: 'ios-rewind', className: 'ion-ios-rewind' },
  { value: 'ios-rewind-outline', className: 'ion-ios-rewind-outline' },
  { value: 'ios-rose', className: 'ion-ios-rose' },
  { value: 'ios-rose-outline', className: 'ion-ios-rose-outline' },
  { value: 'ios-search', className: 'ion-ios-search' },
  { value: 'ios-search-strong', className: 'ion-ios-search-strong' },
  { value: 'ios-settings', className: 'ion-ios-settings' },
  { value: 'ios-settings-strong', className: 'ion-ios-settings-strong' },
  { value: 'ios-shuffle', className: 'ion-ios-shuffle' },
  { value: 'ios-shuffle-strong', className: 'ion-ios-shuffle-strong' },
  { value: 'ios-skipbackward', className: 'ion-ios-skipbackward' },
  { value: 'ios-skipbackward-outline', className: 'ion-ios-skipbackward-outline' },
  { value: 'ios-skipforward', className: 'ion-ios-skipforward' },
  { value: 'ios-skipforward-outline', className: 'ion-ios-skipforward-outline' },
  { value: 'ios-snowy', className: 'ion-ios-snowy' },
  { value: 'ios-speedometer', className: 'ion-ios-speedometer' },
  { value: 'ios-speedometer-outline', className: 'ion-ios-speedometer-outline' },
  { value: 'ios-star', className: 'ion-ios-star' },
  { value: 'ios-star-half', className: 'ion-ios-star-half' },
  { value: 'ios-star-outline', className: 'ion-ios-star-outline' },
  { value: 'ios-stopwatch', className: 'ion-ios-stopwatch' },
  { value: 'ios-stopwatch-outline', className: 'ion-ios-stopwatch-outline' },
  { value: 'ios-sunny', className: 'ion-ios-sunny' },
  { value: 'ios-sunny-outline', className: 'ion-ios-sunny-outline' },
  { value: 'ios-telephone', className: 'ion-ios-telephone' },
  { value: 'ios-telephone-outline', className: 'ion-ios-telephone-outline' },
  { value: 'ios-tennisball', className: 'ion-ios-tennisball' },
  { value: 'ios-tennisball-outline', className: 'ion-ios-tennisball-outline' },
  { value: 'ios-thunderstorm', className: 'ion-ios-thunderstorm' },
  { value: 'ios-thunderstorm-outline', className: 'ion-ios-thunderstorm-outline' },
  { value: 'ios-time', className: 'ion-ios-time' },
  { value: 'ios-time-outline', className: 'ion-ios-time-outline' },
  { value: 'ios-timer', className: 'ion-ios-timer' },
  { value: 'ios-timer-outline', className: 'ion-ios-timer-outline' },
  { value: 'ios-toggle', className: 'ion-ios-toggle' },
  { value: 'ios-toggle-outline', className: 'ion-ios-toggle-outline' },
  { value: 'ios-trash', className: 'ion-ios-trash' },
  { value: 'ios-trash-outline', className: 'ion-ios-trash-outline' },
  { value: 'ios-undo', className: 'ion-ios-undo' },
  { value: 'ios-undo-outline', className: 'ion-ios-undo-outline' },
  { value: 'ios-unlocked', className: 'ion-ios-unlocked' },
  { value: 'ios-unlocked-outline', className: 'ion-ios-unlocked-outline' },
  { value: 'ios-upload', className: 'ion-ios-upload' },
  { value: 'ios-upload-outline', className: 'ion-ios-upload-outline' },
  { value: 'ios-videocam', className: 'ion-ios-videocam' },
  { value: 'ios-videocam-outline', className: 'ion-ios-videocam-outline' },
  { value: 'ios-volume-high', className: 'ion-ios-volume-high' },
  { value: 'ios-volume-low', className: 'ion-ios-volume-low' },
  { value: 'ios-wineglass', className: 'ion-ios-wineglass' },
  { value: 'ios-wineglass-outline', className: 'ion-ios-wineglass-outline' },
  { value: 'ios-world', className: 'ion-ios-world' },
  { value: 'ios-world-outline', className: 'ion-ios-world-outline' },
  { value: 'ipad', className: 'ion-ipad' },
  { value: 'iphone', className: 'ion-iphone' },
  { value: 'ipod', className: 'ion-ipod' },
  { value: 'jet', className: 'ion-jet' },
  { value: 'key', className: 'ion-key' },
  { value: 'knife', className: 'ion-knife' },
  { value: 'laptop', className: 'ion-laptop' },
  { value: 'leaf', className: 'ion-leaf' },
  { value: 'levels', className: 'ion-levels' },
  { value: 'lightbulb', className: 'ion-lightbulb' },
  { value: 'link', className: 'ion-link' },
  { value: 'load-a', className: 'ion-load-a' },
  { value: 'load-b', className: 'ion-load-b' },
  { value: 'load-c', className: 'ion-load-c' },
  { value: 'load-d', className: 'ion-load-d' },
  { value: 'location', className: 'ion-location' },
  { value: 'lock-combination', className: 'ion-lock-combination' },
  { value: 'locked', className: 'ion-locked' },
  { value: 'log-in', className: 'ion-log-in' },
  { value: 'log-out', className: 'ion-log-out' },
  { value: 'loop', className: 'ion-loop' },
  { value: 'magnet', className: 'ion-magnet' },
  { value: 'male', className: 'ion-male' },
  { value: 'man', className: 'ion-man' },
  { value: 'map', className: 'ion-map' },
  { value: 'medkit', className: 'ion-medkit' },
  { value: 'merge', className: 'ion-merge' },
  { value: 'mic-a', className: 'ion-mic-a' },
  { value: 'mic-b', className: 'ion-mic-b' },
  { value: 'mic-c', className: 'ion-mic-c' },
  { value: 'minus', className: 'ion-minus' },
  { value: 'minus-circled', className: 'ion-minus-circled' },
  { value: 'minus-round', className: 'ion-minus-round' },
  { value: 'model-s', className: 'ion-model-s' },
  { value: 'monitor', className: 'ion-monitor' },
  { value: 'more', className: 'ion-more' },
  { value: 'mouse', className: 'ion-mouse' },
  { value: 'music-note', className: 'ion-music-note' },
  { value: 'navicon', className: 'ion-navicon' },
  { value: 'navicon-round', className: 'ion-navicon-round' },
  { value: 'navigate', className: 'ion-navigate' },
  { value: 'network', className: 'ion-network' },
  { value: 'no-smoking', className: 'ion-no-smoking' },
  { value: 'nuclear', className: 'ion-nuclear' },
  { value: 'outlet', className: 'ion-outlet' },
  { value: 'paintbrush', className: 'ion-paintbrush' },
  { value: 'paintbucket', className: 'ion-paintbucket' },
  { value: 'paper-airplane', className: 'ion-paper-airplane' },
  { value: 'paperclip', className: 'ion-paperclip' },
  { value: 'pause', className: 'ion-pause' },
  { value: 'person', className: 'ion-person' },
  { value: 'person-add', className: 'ion-person-add' },
  { value: 'person-stalker', className: 'ion-person-stalker' },
  { value: 'pie-graph', className: 'ion-pie-graph' },
  { value: 'pin', className: 'ion-pin' },
  { value: 'pinpoint', className: 'ion-pinpoint' },
  { value: 'pizza', className: 'ion-pizza' },
  { value: 'plane', className: 'ion-plane' },
  { value: 'planet', className: 'ion-planet' },
  { value: 'play', className: 'ion-play' },
  { value: 'playstation', className: 'ion-playstation' },
  { value: 'plus', className: 'ion-plus' },
  { value: 'plus-circled', className: 'ion-plus-circled' },
  { value: 'plus-round', className: 'ion-plus-round' },
  { value: 'podium', className: 'ion-podium' },
  { value: 'pound', className: 'ion-pound' },
  { value: 'power', className: 'ion-power' },
  { value: 'pricetag', className: 'ion-pricetag' },
  { value: 'pricetags', className: 'ion-pricetags' },
  { value: 'printer', className: 'ion-printer' },
  { value: 'pull-request', className: 'ion-pull-request' },
  { value: 'qr-scanner', className: 'ion-qr-scanner' },
  { value: 'quote', className: 'ion-quote' },
  { value: 'radio-waves', className: 'ion-radio-waves' },
  { value: 'record', className: 'ion-record' },
  { value: 'refresh', className: 'ion-refresh' },
  { value: 'reply', className: 'ion-reply' },
  { value: 'reply-all', className: 'ion-reply-all' },
  { value: 'ribbon-a', className: 'ion-ribbon-a' },
  { value: 'ribbon-b', className: 'ion-ribbon-b' },
  { value: 'sad', className: 'ion-sad' },
  { value: 'sad-outline', className: 'ion-sad-outline' },
  { value: 'scissors', className: 'ion-scissors' },
  { value: 'search', className: 'ion-search' },
  { value: 'settings', className: 'ion-settings' },
  { value: 'share', className: 'ion-share' },
  { value: 'shuffle', className: 'ion-shuffle' },
  { value: 'skip-backward', className: 'ion-skip-backward' },
  { value: 'skip-forward', className: 'ion-skip-forward' },
  { value: 'social-android', className: 'ion-social-android' },
  { value: 'social-android-outline', className: 'ion-social-android-outline' },
  { value: 'social-angular', className: 'ion-social-angular' },
  { value: 'social-angular-outline', className: 'ion-social-angular-outline' },
  { value: 'social-apple', className: 'ion-social-apple' },
  { value: 'social-apple-outline', className: 'ion-social-apple-outline' },
  { value: 'social-bitcoin', className: 'ion-social-bitcoin' },
  { value: 'social-bitcoin-outline', className: 'ion-social-bitcoin-outline' },
  { value: 'social-buffer', className: 'ion-social-buffer' },
  { value: 'social-buffer-outline', className: 'ion-social-buffer-outline' },
  { value: 'social-chrome', className: 'ion-social-chrome' },
  { value: 'social-chrome-outline', className: 'ion-social-chrome-outline' },
  { value: 'social-codepen', className: 'ion-social-codepen' },
  { value: 'social-codepen-outline', className: 'ion-social-codepen-outline' },
  { value: 'social-css3', className: 'ion-social-css3' },
  { value: 'social-css3-outline', className: 'ion-social-css3-outline' },
  { value: 'social-designernews', className: 'ion-social-designernews' },
  { value: 'social-designernews-outline', className: 'ion-social-designernews-outline' },
  { value: 'social-dribbble', className: 'ion-social-dribbble' },
  { value: 'social-dribbble-outline', className: 'ion-social-dribbble-outline' },
  { value: 'social-dropbox', className: 'ion-social-dropbox' },
  { value: 'social-dropbox-outline', className: 'ion-social-dropbox-outline' },
  { value: 'social-euro', className: 'ion-social-euro' },
  { value: 'social-euro-outline', className: 'ion-social-euro-outline' },
  { value: 'social-facebook', className: 'ion-social-facebook' },
  { value: 'social-facebook-outline', className: 'ion-social-facebook-outline' },
  { value: 'social-foursquare', className: 'ion-social-foursquare' },
  { value: 'social-foursquare-outline', className: 'ion-social-foursquare-outline' },
  { value: 'social-freebsd-devil', className: 'ion-social-freebsd-devil' },
  { value: 'social-github', className: 'ion-social-github' },
  { value: 'social-github-outline', className: 'ion-social-github-outline' },
  { value: 'social-google', className: 'ion-social-google' },
  { value: 'social-google-outline', className: 'ion-social-google-outline' },
  { value: 'social-googleplus', className: 'ion-social-googleplus' },
  { value: 'social-googleplus-outline', className: 'ion-social-googleplus-outline' },
  { value: 'social-hackernews', className: 'ion-social-hackernews' },
  { value: 'social-hackernews-outline', className: 'ion-social-hackernews-outline' },
  { value: 'social-html5', className: 'ion-social-html5' },
  { value: 'social-html5-outline', className: 'ion-social-html5-outline' },
  { value: 'social-instagram', className: 'ion-social-instagram' },
  { value: 'social-instagram-outline', className: 'ion-social-instagram-outline' },
  { value: 'social-javascript', className: 'ion-social-javascript' },
  { value: 'social-javascript-outline', className: 'ion-social-javascript-outline' },
  { value: 'social-linkedin', className: 'ion-social-linkedin' },
  { value: 'social-linkedin-outline', className: 'ion-social-linkedin-outline' },
  { value: 'social-markdown', className: 'ion-social-markdown' },
  { value: 'social-nodejs', className: 'ion-social-nodejs' },
  { value: 'social-octocat', className: 'ion-social-octocat' },
  { value: 'social-pinterest', className: 'ion-social-pinterest' },
  { value: 'social-pinterest-outline', className: 'ion-social-pinterest-outline' },
  { value: 'social-python', className: 'ion-social-python' },
  { value: 'social-reddit', className: 'ion-social-reddit' },
  { value: 'social-reddit-outline', className: 'ion-social-reddit-outline' },
  { value: 'social-rss', className: 'ion-social-rss' },
  { value: 'social-rss-outline', className: 'ion-social-rss-outline' },
  { value: 'social-sass', className: 'ion-social-sass' },
  { value: 'social-skype', className: 'ion-social-skype' },
  { value: 'social-skype-outline', className: 'ion-social-skype-outline' },
  { value: 'social-snapchat', className: 'ion-social-snapchat' },
  { value: 'social-snapchat-outline', className: 'ion-social-snapchat-outline' },
  { value: 'social-tumblr', className: 'ion-social-tumblr' },
  { value: 'social-tumblr-outline', className: 'ion-social-tumblr-outline' },
  { value: 'social-tux', className: 'ion-social-tux' },
  { value: 'social-twitch', className: 'ion-social-twitch' },
  { value: 'social-twitch-outline', className: 'ion-social-twitch-outline' },
  { value: 'social-twitter', className: 'ion-social-twitter' },
  { value: 'social-twitter-outline', className: 'ion-social-twitter-outline' },
  { value: 'social-usd', className: 'ion-social-usd' },
  { value: 'social-usd-outline', className: 'ion-social-usd-outline' },
  { value: 'social-vimeo', className: 'ion-social-vimeo' },
  { value: 'social-vimeo-outline', className: 'ion-social-vimeo-outline' },
  { value: 'social-whatsapp', className: 'ion-social-whatsapp' },
  { value: 'social-whatsapp-outline', className: 'ion-social-whatsapp-outline' },
  { value: 'social-windows', className: 'ion-social-windows' },
  { value: 'social-windows-outline', className: 'ion-social-windows-outline' },
  { value: 'social-wordpress', className: 'ion-social-wordpress' },
  { value: 'social-wordpress-outline', className: 'ion-social-wordpress-outline' },
  { value: 'social-yahoo', className: 'ion-social-yahoo' },
  { value: 'social-yahoo-outline', className: 'ion-social-yahoo-outline' },
  { value: 'social-yen', className: 'ion-social-yen' },
  { value: 'social-yen-outline', className: 'ion-social-yen-outline' },
  { value: 'social-youtube', className: 'ion-social-youtube' },
  { value: 'social-youtube-outline', className: 'ion-social-youtube-outline' },
  { value: 'soup-can', className: 'ion-soup-can' },
  { value: 'soup-can-outline', className: 'ion-soup-can-outline' },
  { value: 'speakerphone', className: 'ion-speakerphone' },
  { value: 'speedometer', className: 'ion-speedometer' },
  { value: 'spoon', className: 'ion-spoon' },
  { value: 'star', className: 'ion-star' },
  { value: 'stats-bars', className: 'ion-stats-bars' },
  { value: 'steam', className: 'ion-steam' },
  { value: 'stop', className: 'ion-stop' },
  { value: 'thermometer', className: 'ion-thermometer' },
  { value: 'thumbsdown', className: 'ion-thumbsdown' },
  { value: 'thumbsup', className: 'ion-thumbsup' },
  { value: 'toggle', className: 'ion-toggle' },
  { value: 'toggle-filled', className: 'ion-toggle-filled' },
  { value: 'transgender', className: 'ion-transgender' },
  { value: 'trash-a', className: 'ion-trash-a' },
  { value: 'trash-b', className: 'ion-trash-b' },
  { value: 'trophy', className: 'ion-trophy' },
  { value: 'tshirt', className: 'ion-tshirt' },
  { value: 'tshirt-outline', className: 'ion-tshirt-outline' },
  { value: 'umbrella', className: 'ion-umbrella' },
  { value: 'university', className: 'ion-university' },
  { value: 'unlocked', className: 'ion-unlocked' },
  { value: 'upload', className: 'ion-upload' },
  { value: 'usb', className: 'ion-usb' },
  { value: 'videocamera', className: 'ion-videocamera' },
  { value: 'volume-high', className: 'ion-volume-high' },
  { value: 'volume-low', className: 'ion-volume-low' },
  { value: 'volume-medium', className: 'ion-volume-medium' },
  { value: 'volume-mute', className: 'ion-volume-mute' },
  { value: 'wand', className: 'ion-wand' },
  { value: 'waterdrop', className: 'ion-waterdrop' },
  { value: 'wifi', className: 'ion-wifi' },
  { value: 'wineglass', className: 'ion-wineglass' },
  { value: 'woman', className: 'ion-woman' },
  { value: 'wrench', className: 'ion-wrench' },
  { value: 'xbox', className: 'ion-xbox' },
];
